// extracted by mini-css-extract-plugin
export default {"wrapper":"MergeItem_wrapper__t7jPp","selected":"MergeItem_selected__wCZYa","dragging":"MergeItem_dragging__WtUTK"};